import AxiosInstance from "../services/networkServices";

export const getCuratedMatches = async () => {
  const res = await AxiosInstance.get("/admin/curated-matches");
  return res.data;
};

/**
 * @param {Array<{ originalMatchId: string }>} curatedMatches - Each element must include originalMatchId (from GET list response).
 */
export const setCuratedMatches = async (curatedMatches) => {
  const res = await AxiosInstance.post("/admin/curated-matches", {
    matchIds: curatedMatches,
  });
  return res.data;
};

export const removeCuratedMatch = async (id) => {
  const res = await AxiosInstance.delete(`/admin/curated-matches/${id}`);
  return res.data;
};

export const resetCuratedMatchVotes = async (id) => {
  const res = await AxiosInstance.put(`/admin/curated-matches/${id}/reset`);
  return res.data;
};
